import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, CircularProgress, Button, Table, TableHead, TableBody, TableCell, TableRow, TableContainer, Pagination } from '@mui/material'
import { styled } from '@mui/material/styles';
import { csvFormat } from '../../../utils/csvSur' // B47 : export sans formule
import { v4 as uuidv4 } from 'uuid';
import PopupNotifContext from "../../../contexts/PopupNotifContext"

import Moment from 'moment'
import 'moment/locale/fr';

import APIS from "../../../utils/APIS"

import SelectEcoleMenuMobile from "./SelectEcoleMenuMobile"
import MyPopover from "../MyPopover"

import { Header, FiltersDisplay, FilterList, FiltresInline, ItemPopover } from "./Suivi"
// 03/09 : pour ne pas afficher au client la casse technique des contenus
import { libelleAffichable } from "../../../utils/referentielSoftSkills"
import { ModalTuto } from "./Home"

import CertifModal, { LegendeRadar } from "./CertifModal"
import NoDataScreen from "./NoDataScreen"
import SkeletonEcran from "./SkeletonEcran"

import NewCertifChart from "../NewCertifChart"


import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"


import searchIcon from "../../../images/searchIcon.svg"
import exportIcon from "../../../images/exportIcon.svg"
import filterIcon from "../../../images/filterIcon.svg"
import checkGreenRoundIcon from "../../../images/checkGreenRoundIcon.svg"
import closeRedRoundIcon from "../../../images/closeRedRoundIcon.svg"
import sablierIcon from "../../../images/sablierIcon.svg"
import closeIcon from '../../../images/closeIcon.svg';



Moment.locale('fr')

const ActionList = ({ glbData, filters, setFilters, icebreakerQuestions }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [actItem, setActItem] = useState(null)
  const menuOpenClose = (item) => {
    if (item === actItem) {
      setActItem(null)
    } else {
      setActItem(item)
    }
  }

  return (
    <Box sx={{display:"flex", alignItems:"flex-start"}}>
      <Box sx={{
        minWidth:"220px",
        maxWidth:"350px",
        padding:"10px 20px",
        boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
        border: "1px solid black",
        background:"white",
      }}>
        {actEcole?.groupes?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.groupe[actLanguage]}
              onClick={() => {menuOpenClose("groupe")}} selected={actItem === "groupe"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "groupe" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                  datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {/* Meme filtre que le menu en ligne : annee d'ETUDE, donc conditionne
            par `annees` et non par `diplome`. */}
        {icebreakerQuestions?.annees === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.studyYear[actLanguage]}
              onClick={() => {menuOpenClose("diplome")}} selected={actItem === "diplome"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "diplome" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                  datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {actEcole?.campus?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.campus[actLanguage]}
              onClick={() => {menuOpenClose("campus")}} selected={actItem === "campus"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "campus" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                  datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.progress[actLanguage]}
          onClick={() => {menuOpenClose("status")}} selected={actItem === "status"} icon={filterIcon}
        />
        <Hidden mdUp>
          {actItem === "status" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.progressSub[actLanguage]}
              datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.level[actLanguage]}
          onClick={() => {menuOpenClose("level")}} selected={actItem === "level"} icon={filterIcon}
        />
        <Hidden mdUp>
          {actItem === "level" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.levelSub[actLanguage]}
              datas={levelTypes} filterType="level" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
      </Box>
      <Hidden mdDown>
        {actItem !== null &&
          <Box sx={{
            marginLeft:"10px",
            maxWidth:"350px",
            minWidth:"200px",
            padding:"10px 20px",
            boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
            border: "1px solid black",
            background:"white",
          }}>
            {actItem === "groupe" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "campus" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "diplome" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "status" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.progressSub[actLanguage]}
                datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "level" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.levelSub[actLanguage]}
                datas={levelTypes} filterType="level" filters={filters} setFilters={setFilters}
              />
            }
          </Box>
        }
      </Hidden>
    </Box>
  )
}


let defautFilters = {
  groupes : [],
  campus : [],
  anneesDiplome : [],
  status : [],
  level : [],
}
let statusTypes = ['notStarted', 'inProgress', 'ended']

/* S2, volet Certification : largeurs de colonnes posees sur l'en-tete, le corps
   s'y aligne via `table-layout: fixed`.

   04/09 — MEME CORRECTIF QUE LE SUIVI. « Nom » n'avait pas de largeur : elle
   prenait la place restante, et tombait donc a zero des que les autres
   colonnes ne tenaient plus. Ici le danger est plus sournois qu'ailleurs : ce
   tableau RETRECIT quand le volet apprenant s'ouvre, geste que l'on fait a
   chaque demonstration. Les 840 px de colonnes fixes ne tenaient plus dans la
   largeur restante, et la colonne des noms disparaissait.

   En parts relatives, le navigateur renormalise sur les colonnes reellement
   rendues — elles sont conditionnelles — et aucune ne peut valoir zero.
   « Nom » garde la plus grande part quel que soit le sous-ensemble. */
const LARGEUR_COL_CERTIF = {
  nom           : "22%",
  certification : "18%",
  anneeEtude    : "15%",
  campus        : "16%",
  progression   : "17%",
  niveau        : "18%",
}
let levelTypes = ['notAcquired', 'rattrapage', 'inProgress', 'acquired']

const Certification = ({ }) => {

  const {
    ecoles,
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)


  const [dataLoaded, setDataLoaded] = useState(false)
  // E2 review 02/09 : vrai etat « pas de donnees » au lieu d'un chargement sans fin
  const [aucuneDonnee, setAucuneDonnee] = useState(false)
  // Relecture finale 02/09 : distinguer « rien a montrer » de « serveur muet »
  const [reseauCoupe, setReseauCoupe] = useState(false)
  const [glbData, setGlbData] = useState(null)
  const [filteredData, setFilteredData] = useState([])
  const [filters, setFilters] = useState(defautFilters)

  const [selectedID, setSelectedID] = useState(null)

  const [nbrPage, setNbrPage] = useState(1)
  const [page, setPage] = useState(1)
  // F8 (retours Hicham 03/09) : meme barre de recherche que le Suivi
  const [recherche, setRecherche] = useState("")

  const [popoverFilters, setPopoverFilters] = useState(false)
  const popoverRef = useRef()

  const [modalCertif, setModalCertif] = useState(false)

  /* C2 niveau 2 (fiche V3 de Nawal, 03/09) : le detail chiffre scores/seuils
     passe en zone secondaire, replie par defaut, derriere un « Voir plus ».
     Declare ICI, avec les autres etats, et surtout AVANT tout calcul qui le
     lit : un etat declare plus bas qu'un memo qui en depend a deja coute un
     ecran blanc sur Progression (JOURNAL-DES-ERREURS.md, motif M13). */
  const [detailSeuilsOuvert, setDetailSeuilsOuvert] = useState(false)


  useEffect(() => {
    setDataLoaded(false)
    if (actEcole?.groupes?.length > 0) {
      let fetchData = []
      actEcole?.groupes?.forEach((g) => {
        if (g.icebreaker !== null && g.certification) {
          let ids = []
          g?.plan?.plan?.forEach((p) => {
            ids.push(p.id)
          })
          fetchData.push({
            groupeID : g.groupeID,
            ids : ids,
            icebreaker : g.icebreaker
          })
        }
      })
      if (fetchData.length === 0) {
        // aucun groupe de l'ecole n'a de certification configuree : avant, la
        // page restait bloquee sur le chargement (percu « page blanche », A1)
        setAucuneDonnee(true)
      } else {
        setAucuneDonnee(false)
        setReseauCoupe(false)
        APIS.clientAdminSuivi({fetchData : fetchData}).then((result) => {
          if (result?.value?.length > 0) {
            let dataToPass = []
            result?.value?.forEach((d) => {
              if (d.isOk === true && d.contents && d.results) {
                let finalData = {groupeID : d.groupeID}

                //on rechercher les résultats pour chaque user
                d?.users?.forEach((user) => {
                  user.results = []
                  let nbrEndedModule = 0
                  d?.contents?.forEach((content) => {
                    let find = d.results.find((el) => el.contentID === content.id && el.userID === user.id)
                    if (find) {
                      user.results.push(find)
                      if (find?.isDone === true && find?.progress === 100) {
                        nbrEndedModule++;
                      }
                    }
                  });
                  if (nbrEndedModule === 0 || d?.contents?.length === 0) { //pas commencé
                    user.statusProgress = 0
                    user.status = 'notStarted'
                    user.level = 'inProgress'
                  } else if (nbrEndedModule === d?.contents?.length) { //tout terminé
                    user.statusProgress = 100
                    user.status = 'ended'
                  } else { //en cours
                    user.statusProgress = Math.round( (nbrEndedModule / d?.contents?.length) * 100 )
                    user.status = 'inProgress'
                    user.level = 'inProgress'
                  }
                });

                //on regarde les softskills
                let labelsContent = []
                d?.contents?.forEach((module) => {
                  module?.softSkills?.forEach((skill) => {
                    if (skill.value === 'oui') {
                      labelsContent.push(skill)
                    }
                  });
                })

                let labelsCertif = []
                let thisGroupCertification = actEcole?.groupes?.find((el) => el.groupeID === d?.groupeID)?.certification
                thisGroupCertification?.forEach((module) => {
                  module?.softSkills?.forEach((skill) => {
                    labelsCertif.push(skill)
                  })
                })
                //on filtre pour n'avoir que les softskills présent en certif
                labelsContent.filter((el) => {
                  let find = labelsCertif.find((el2) => el2.key === el.key)
                  if (find) {
                    return true
                  } else { return false }
                })

                labelsContent = labelsContent.sort(function (a, b) {
                  if (a.family < b.family) {
                    return -1;
                  }
                  if (a.family > b.family) {
                    return 1;
                  }
                  return 0;
                });

                let uniqueLabels = Array.from(new Set(labelsContent.map(a => a.key)))
                 .map(id => {
                   return labelsContent.find(a => a.key === id)
                 })


                finalData.labels = uniqueLabels

                d?.users?.forEach((user) => {
                  if (user?.status === "ended") {
                    let diplomeOK = false
                    let nbrErreurDiplome = 0
                    let nbrSoftSkills = 0;
                    thisGroupCertification?.forEach((content) => {
                      let findContentInResult = user?.results?.find((el) => el.contentID === content.id)
                      content?.softSkills?.forEach((softskill) => {
                        nbrSoftSkills++
                        let findResult = findContentInResult?.resultFin?.[softskill.key]   // M3 : resultFin peut etre null
                        if (findResult?.score === undefined || findResult?.score === null || findResult?.score < softskill.validation) {
                          nbrErreurDiplome++
                        }
                      })
                    })
                    let nbrOKDiplome = nbrSoftSkills - nbrErreurDiplome;
                    let percentOK = (nbrOKDiplome/nbrSoftSkills)*100
                    if (percentOK >= 70) {
                      user.level = 'acquired'
                    } else if (percentOK >= 50) {
                      user.level = 'rattrapage'
                    } else {
                      user.level = 'notAcquired'
                    }
                  }
                })

                finalData.contents = d?.contents
                finalData.users = d?.users

                dataToPass.push(finalData)
              }
            });


            let finalData = {
              contents : [],
              users : [],
              labelsPerGroup : []
            }

            dataToPass.forEach((data) => {
              data?.contents?.forEach((content) => {
                finalData?.contents?.push(content)
              })
              data?.users?.forEach((user) => {
                finalData?.users?.push({...user, groupeIDForCertif : data?.groupeID})
              })
              finalData?.labelsPerGroup?.push({
                groupeID : data.groupeID,
                labels : data?.labels
              })
            })


            setGlbData(finalData)
            setDataLoaded(true)
          } else {
            setDataLoaded(false)
            setAucuneDonnee(true)
            setReseauCoupe(result?.reseauIndisponible === true)
          }
        })
      }
    } else {
      // Relecture 02/09 (bis) : ecole sans aucun groupe, sinon chargement sans fin
      setAucuneDonnee(true)
    }
  }, [actEcole])

  useEffect(() => {
    if (glbData !== null) {
      let newArr = []
      if (glbData.contents && glbData.contents.length > 0 && glbData.users && glbData.users.length > 0) {
        glbData.users.forEach((res) => {
          let findSubGroup = actEcole?.groupes?.find((el) => el.groupeID === res?.groupeIDForCertif)
          let obj = {
            groupeID : res?.groupeIDForCertif,
            campusID : res?.campusID,
            userName : res.name,
            userID : res.id,
            //anneeDiplome : res.icebreakerResults?.diplome || null,
            anneeDiplome : res.icebreakerResults?.annees || null,
            // F5 (retours Hicham 03/09) : le nom du diplome (Master, Licence
            // professionnelle...) vient de l'icebreaker. Il etait remonte dans le
            // Suivi mais pas ici, d'ou son absence de la fiche et de l'export.
            nomDiplome : res.icebreakerResults?.diplome || null,
            diplome : findSubGroup?.diplome || "-",
            statusProgress : res.statusProgress,
            status : res.status,
            level : res.level,
            results : res.results
          }
          newArr.push(obj)
        })
      }

      //filtered
      if (filters.groupes.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.groupes.includes(el.groupeID)
        })
      }
      if (filters.campus.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.campus.includes(el.campusID)
        })
      }
      if (filters.anneesDiplome.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.anneesDiplome.includes(el.anneeDiplome)
        })
      }
      if (filters.status.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.status.includes(el.status)
        })
      }
      if (filters.level.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.level.includes(el.level)
        })
      }

      //on trie par ordre alphabétiques
      newArr = newArr.sort((a,b)=>a.userName.localeCompare(b.userName))

      setNbrPage(Math.ceil(newArr.length/25))
      setPage(1)

      //console.log(newArr)
      setFilteredData(newArr)
    }
  }, [glbData, filters])

  useEffect(() => {
    if (selectedID === null) {
      /*if (filteredData.length > 0) {
        setSelectedID(filteredData[0])
      }*/
    } else {
      //on cherche la selectedID dans le tableau
      let find = filteredData.find((el) => el.userID === selectedID?.userID)
      if (!find) {
        if (filteredData.length > 0) {
          setSelectedID(filteredData[0])
        } else {
          setSelectedID(null)
          if (modalCertif === true) {
            setModalCertif(false)
          }
        }
      }
    }
  }, [filteredData, selectedID, modalCertif])


  const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  /* F6 (retours Hicham 03/09) : les seuils de certification n'apparaissaient
   * nulle part dans la fiche apprenant, alors que ce sont eux qui decident du
   * « acquis / non acquis ». Ils sont enregistres dans la configuration du groupe,
   * sous la cle `validation` (et non `seuil`, piege deja rencontre cote
   * Progression). Un groupe sans seuil configure ne fait rien apparaitre :
   * mieux vaut rien qu'un chiffre invente (reponse Q2). */
  const seuilsDuGroupe = (groupeID) => {
    let certif = actEcole?.groupes?.find((el) => el.groupeID === groupeID)?.certification
    if (typeof certif === "string") { try { certif = JSON.parse(certif) } catch (e) { certif = null } }
    if (!Array.isArray(certif)) return []
    /* Un groupe peut fixer un seuil DIFFERENT par module — le groupe 96 demande
       40 sur « Core Scan FULL 1 » et 50 sur « FULL 2 », la barre monte en cours
       de parcours. Le seuil qui compte pour un bilan est donc celui du DERNIER
       module, l'objectif d'arrivee. On laisse volontairement les modules
       suivants ecraser les precedents, comme le fait l'ecran Progression : sans
       cela les deux ecrans affichaient deux seuils differents pour la meme
       competence (40 ici, 50 la-bas). */
    const parCle = new Map()
    certif.forEach((mod) => (mod?.softSkills || []).forEach?.((sk) => {
      const val = parseInt(sk?.validation !== undefined ? sk.validation : sk?.seuil)
      if (sk?.key && !isNaN(val)) parCle.set(sk.key, val)
    }))
    return Array.from(parCle, ([key, seuil]) => ({ key, seuil }))
  }

  /* L'ordre chronologique des contenus d'un groupe : annees croissantes, et
     dans chaque annee l'ordre du plan. C'est le seul ordre dont on dispose —
     les resultats, eux, n'arrivent pas tries. */
  const contenusOrdonnes = (groupeID) => {
    const plan = actEcole?.groupes?.find((el) => el.groupeID === groupeID)?.plan?.plan || []
    return plan
      .map((m, rang) => ({ id : m?.id, annee : parseInt(m?.annee), rang : rang }))
      .filter((m) => Number.isInteger(m.annee))
      .sort((a, b) => (a.annee - b.annee) || (a.rang - b.rang))
      .map((m) => m.id)
  }

  /* Le niveau atteint par l'apprenant sur une competence : sa mesure LA PLUS
     RECENTE.
     ⚠️ 03/09 — c'etait la MOYENNE de toutes ses mesures. Le groupe 96 fait
     passer deux Core Scan, l'un au debut et l'autre a la fin : l'apprenant
     19295 s'affichait a 82 alors qu'il avait atteint 85, sa progression etant
     diluee dans son point de depart. Le radar juste au-dessus applique la meme
     regle (voir getDatasForChart) : les deux doivent dire la meme chose, sans
     quoi le chiffre contredit le dessin qu'il legende. */
  const scoreObtenu = (apprenant, cle) => {
    const resultats = apprenant?.results || []
    const lire = (r) => {
      const s = r?.resultFin?.[cle]?.score
      return (typeof s === "number" && !isNaN(s)) ? s : null
    }
    let valeur = null
    contenusOrdonnes(apprenant?.groupeID).forEach((id) => {
      const v = lire(resultats.find((x) => x.contentID === id))
      if (v !== null) { valeur = v }
    })
    /* Repli : un resultat portant sur un module retire du plan depuis reste la
       seule mesure disponible, il vaut mieux l'afficher que rien. */
    if (valeur === null) { resultats.forEach((r) => { const v = lire(r); if (v !== null) { valeur = v } }) }
    return valeur === null ? null : Math.round(valeur)
  }

  /* Les seuils de l'apprenant selectionne, calcules une seule fois par rendu.
     Ils etaient recalcules deux fois dans le JSX (une fois pour la condition
     d'affichage, une fois pour la boucle). */
  const seuilsApprenant = seuilsDuGroupe(selectedID?.groupeID)

  /* On repart replie a chaque changement d'apprenant : le detail est une zone
     secondaire, il ne doit pas rester ouvert d'une fiche a l'autre. */
  useEffect(() => {
    setDetailSeuilsOuvert(false)
  }, [selectedID?.userID])

  const getDatasForChart = (data) => {

    let labels = []
    let datasets = []
    let labelsDotColors = []

    let labelsCategories = ['communication','efficacite','leadership']

    let contentsByYear = [[], [], []]
    let resultsByYear = [[], [], []]

    let findLabels = glbData?.labelsPerGroup?.find((el) => el.groupeID === data?.groupeID)?.labels
    findLabels?.forEach((label) => {
      labels.push(libelleAffichable(label.key))
      if (label?.family === labelsCategories[0]) {
        labelsDotColors.push("rgba(255, 81, 6, 1)")
      } else if (label?.family === labelsCategories[1]) {
        labelsDotColors.push("rgba(79, 57, 255, 1)")
      } else if (label?.family === labelsCategories[2]) {
        labelsDotColors.push("rgba(243, 144, 255, 1)")
      }
    })

    let findSubGroup = actEcole?.groupes?.find((el) => el.groupeID === data?.groupeID)
    findSubGroup?.plan?.plan?.forEach((plan) => {
      /* Relecture finale 02/09 : l'index est borne. Le selecteur de l'admin
         n'offre que les annees 1 a 3, mais CertificationModal en accepte 5, et
         rien n'empeche une donnee importee de porter une annee 4 :
         `contentsByYear[3]` vaut alors undefined et le `.push` vidait tout
         l'ecran Certification.
         ⚠️ A trancher avec Hicham : l'interface propose 1 a 3, la certification
         en accepte 5. Tant que l'ecart existe, les annees 4 et 5 sont ignorees
         ici plutot que de changer le calcul de la certification a l'aveugle. */
      const annee = parseInt(plan.annee)
      if (Number.isInteger(annee) && annee >= 1 && annee <= contentsByYear.length) {
        contentsByYear[annee-1].push(plan)
      }
    })

    contentsByYear.forEach((year, index) => {
      if (year.length > 0) {
        year.forEach((module) => {
          let findInResults = data?.results?.find((el) => el.contentID === module.id)
          /* ⛔ La garde porte sur `resultFin`, PAS sur la ligne de resultat.
             `getResultsSuivi` (thelab-back/models/clientAdmin.js) remonte TOUTES
             les lignes contentsResults des contenus du plan, sans filtrer ni
             `isDone` ni `progress`, et met `resultFin` a null quand le JSON est
             absent ou illisible. Un module commence et non termine donne donc
             une ligne dont `resultFin` vaut null. Pousser ce null faisait lever
             `null[cle]` plus bas, pendant le rendu — et comme rien n'attrape les
             erreurs de rendu dans src, c'est l'application entiere qui passait
             au blanc au clic sur l'apprenant. Motif M3 du journal ; le lot du
             03/09 avait corrige six sites de ce type et manque celui-ci. */
          if (findInResults?.resultFin) {
            resultsByYear[index].push(findInResults.resultFin)
          }
        })
      }
    })

    /* 03/09, decision d'Hicham — LE RADAR NE MONTRE PLUS QU'UNE SEULE SERIE.
     *
     * Il en dessinait une PAR ANNEE du plan, distinguees par leur style de
     * trait : pointille pour la 1re, tirets pour la 2e, plein pour la 3e.
     * Rien ne les nommait. Sur la demo Saclay le probleme ne se voyait pas —
     * une seule annee note vraiment, STAY FOCUS ON n'evaluant aucune
     * competence — mais sur un groupe ou deux annees notent, le client voyait
     * deux traces qu'il ne pouvait pas identifier.
     *
     * Le radar n'oppose donc plus que deux choses : ce que l'apprenant a
     * acquis, et la barre a franchir.
     *
     * ⚠️ CE QUE « NIVEAU ACQUIS » VEUT DIRE. Chaque competence prend sa mesure
     * LA PLUS RECENTE, pas la moyenne de toutes. Le radar moyennait le scan
     * initial et le scan final : sur le groupe 96, les deux Core Scan sont
     * declares la meme annee, et l'apprenant 19295 s'affichait a 82 alors qu'il
     * avait atteint 85 — sa progression etait diluee dans son point de depart.
     * Une serie intitulee « Niveau acquis » qui montre la moyenne de l'avant et
     * de l'apres contredit son propre libelle. Une competence mesuree une seule
     * fois garde evidemment cette mesure.
     *
     * L'ordre de lecture est chronologique : annees croissantes, et dans chaque
     * annee l'ordre du plan. La derniere valeur rencontree l'emporte.
     *
     * Les trois couleurs de famille sont conservees : elles ne distinguent pas
     * des series mais des secteurs du cercle, et ce sont les memes que les
     * pastilles autour du graphe. La legende (LegendeRadar, CertifModal) les
     * reprend en degrade sous « Niveau acquis » ; elle se deduit des series
     * reellement dessinees, elle suit donc ce changement sans etre touchee. */
    let finalsResults = []
    {
      const tousLesResultats = resultsByYear.reduce((a, b) => a.concat(b), [])
      const labelsDuGroupe = glbData?.labelsPerGroup?.find((el) => el.groupeID === data?.groupeID)?.labels
      labelsDuGroupe?.forEach((label) => {
        let derniereMesure = null
        tousLesResultats.forEach((result) => {
          /* `result?.[...]` et non `result[...]` : le `?.` doit proteger
             l'acces par crochets, pas seulement `.score`. Ceinture et
             bretelles avec le filtre pose au push juste au-dessus. */
          const score = result?.[label?.key]?.score
          if (score !== undefined) { derniereMesure = score }
        })
        finalsResults.push({
          key : label?.key,
          family : label?.family,
          score : derniereMesure === null ? 0 : derniereMesure,
        })
      })
    }

    const seriesNiveauAcquis = finalsResults.length > 0 ? [finalsResults] : []
    seriesNiveauAcquis.forEach((result) => {
      if (result.length > 0) {
        /* Trait plein. Le seuil reste distinguable : il est neutre, sans
           remplissage et plus epais, la ou le niveau acquis est en couleur et
           rempli. C'est le motif M19 — un trait de reference doit differer de
           toute autre serie autrement que par sa seule couleur. */
        const dashStyle = undefined

        labelsCategories.forEach((cat) => {
          let arr = []
          result.forEach((res) => {
            if (res.family === cat) {
              arr.push(res.score)
            } else {
              arr.push(null)
            }
          })


          let bgColor = ""
          let borderColor = ""
          let tooltipText = ""
          if (cat === labelsCategories[0]) {
            bgColor = "rgba(255, 81, 6, 0.2)"
            borderColor = "rgba(255, 81, 6, 1)"
            tooltipText = "Innovation et\ncommunication"
          } else if (cat === labelsCategories[1]) {
            bgColor = "rgba(79, 57, 255, 0.2)"
            borderColor = "rgba(79, 57, 255, 1)"
            tooltipText = "Efficacité\nopérationnelle"
          } else if (cat === labelsCategories[2]) {
            bgColor = "rgba(243, 144, 255, 0.2)"
            borderColor = "rgba(243, 144, 255, 1)"
            tooltipText = "Collaboration et\nleadership"
          }


          datasets.push({
            /* Portait l'index de l'annee, qui n'existe plus. Aucune lecture de
               ce champ ailleurs : la legende distingue les series par
               `estSeuil`, pas par `title`. */
            title : "niveau",
            data : arr,
            fill : true,
            backgroundColor: bgColor,
            borderColor: borderColor,
            borderDash : dashStyle,
            borderWidth : 1,
            pointRadius: 0,
            pointHoverRadius: 0,
            tooltipText: tooltipText,
          })
        })
      }
    })

    datasets = datasets.filter((el) => {
      let total = 0

      el?.data?.forEach((nbr) => {
        total += nbr
      })

      if (total === 0) { return false } else { return true }
    })

    //on regarde si on a des labels à supprimer
    let indexesToBeDeleted = []
    labels = labels.map((label, index) => {
      let total = 0
      datasets.forEach((data) => {
        /* Motif M4 : le `?.` ne protegeait que `data`, pas `data.data`. Un jeu
           de series ou l'un des elements n'a pas de tableau `data` faisait
           lever `undefined[index]` — ecran blanc. Et sans le `|| 0`, un trou
           rendait `total` NaN, donc jamais 0 : la colonne vide etait gardee. */
        total += (data?.data?.[index] || 0)
      })
      if (total === 0) {
        indexesToBeDeleted.push(index)
        labelsDotColors[index] = "toDelete"
        return false
      } else {
        return label
      }
    })
    indexesToBeDeleted = indexesToBeDeleted.reverse();

    datasets.forEach((data) => {
      indexesToBeDeleted.forEach((i) => {
        data.data.splice(i, 1)
      })
    })

    datasets.forEach((data) => {
      let nbrNotNull = data?.data?.filter((el) => el !== null)?.length
      data.labelsNbr = nbrNotNull
      data?.data?.forEach((val, index) => {
        if (val === null) {
          data.data[index] = 0
        }
      })
    })

    labelsDotColors = labelsDotColors.filter((el) => el !== "toDelete")

    labels = labels.filter((el) => el !== false)

    //on doit réorganiser les datasets
    let firstIndexPerDataset = []
    datasets.forEach((data, index) => {
      firstIndexPerDataset.push({datasetIndex : index, firstNonZero : data?.data?.findIndex((el) => el > 0)})
    })
    firstIndexPerDataset = firstIndexPerDataset.sort(function(a, b) {
      if (a?.firstNonZero < b?.firstNonZero) return -1;
      if (a?.firstNonZero > b?.firstNonZero) return 1;
      return 0;
    });

    let newDatasets = []
    firstIndexPerDataset?.forEach((data, index) => {
      newDatasets.push(datasets[data?.datasetIndex])
    })

    datasets = newDatasets


    //on regarde pour lier les lignes
    let indexLabels = 0
    for (let d=0; d<datasets.length; d++) {
      //pour le premier dataset
      if (d === 0 && datasets?.length >= 2) { //pour le premier dataset
        let actDataset = datasets[d]
        let nextDataset = datasets[d+1]

        actDataset.data[actDataset?.labelsNbr] = nextDataset.data[actDataset?.labelsNbr]
      } else if (d === datasets?.length-1) { //pour le dernier dataset
        let actDataset = datasets[d]
        let firstDataset = datasets[0]
        actDataset.data[0] = firstDataset.data[0]
      } else {
        let actDataset = datasets[d]
        let nextDataset =  datasets[d+1]
        actDataset.data[indexLabels + datasets[d]?.labelsNbr] = nextDataset.data[indexLabels + datasets[d]?.labelsNbr]
      }

      indexLabels += datasets[d]?.labelsNbr
    }


    /* C2 (fiche V3 de Nawal, 03/09) — NIVEAU 1 : le seuil DANS le radar.
     *
     * Les seuils n'etaient lisibles que sous forme de chiffres sous le radar :
     * impossible de comparer d'un coup d'oeil un score a son seuil. On ajoute
     * une derniere serie, en trait de reference ferme, sans remplissage.
     *
     * ⚠️ Elle est ajoutee ICI, tout a la fin, APRES le decoupage par famille et
     * la liaison des segments juste au-dessus. Ces traitements decoupent les
     * series par famille et raccordent leurs extremites ; une serie qui doit
     * faire le tour complet du radar n'y survivrait pas. Ne pas la deplacer
     * plus haut dans la fonction. */
    const seuilsRadar = seuilsDuGroupe(data?.groupeID)
    if (seuilsRadar.length > 0 && labels.length > 0) {
      const parCle = {}
      seuilsRadar.forEach((x) => { parCle[libelleAffichable(x.key)] = x.seuil })
      const serie = labels.map((l) => (typeof parCle[l] === "number" ? parCle[l] : null))
      if (serie.some((v) => v !== null)) {
        /* 04/09 — ON NE COMBLE PLUS LES TROUS. La version precedente recopiait
           la valeur voisine connue pour que le trait fasse un anneau continu.
           Elle inventait donc un seuil sur les axes qui n'en ont pas : c'est le
           cas des competences d'un contenu ajoute au plan APRES la saisie de la
           certification, qui deviennent des axes du radar sans avoir de
           `validation`. Le client lisait une barre a franchir la ou le client
           n'en a fixe aucune. Un trait interrompu dit la verite : ici, pas de
           seuil. Sans effet sur le groupe 96, dont les 18 competences ont
           toutes un seuil — verifie en base le 04/09. */
        const pleine = serie
        datasets.push({
          title : "seuil",
          estSeuil : true,
          data : pleine,
          fill : false,
          backgroundColor : "transparent",
          /* Relecture au navigateur, 03/09 : ce trait etait en TIRETS, exactement
             comme la serie « Annee 2 » de la legende — impossible de les
             distinguer, et il n'avait aucune entree de legende. Les trois annees
             occupent deja pointille, tirets et plein, mais toujours EN COULEUR
             (par famille). Le seuil se distingue donc par sa couleur neutre et
             son epaisseur, et il a desormais sa legende. */
          /* 04/09 — aligne sur l'export Figma d'Hicham : le seuil y est un
             anneau GRIS FIN, nettement secondaire. En noir a 2,5 px il
             dominait le graphe et l'oeil allait a la barre a franchir plutot
             qu'au niveau atteint, alors que c'est l'inverse qu'on veut
             montrer. Il reste parfaitement identifiable — couleur neutre,
             sans remplissage, la ou le niveau est en couleur et rempli.
             ⚠️ Le temoin de la legende (CertifModal, LegendeRadar) doit rester
             IDENTIQUE a ce trait : une legende qui ne ressemble pas a ce
             qu'elle nomme ne sert a rien (motif M19). */
          borderColor : "rgba(10,10,11,0.5)",
          borderWidth : 2,
          pointRadius : 0,
          pointHoverRadius : 0,
          tooltipText : "Seuil de certification",
          labelsNbr : labels.length,
        })
      }
    }

    return {
      labels : labels,
      datasets : datasets,
      labelsDotColors : labelsDotColors,
      labelsIcons : undefined,
      /* C4 (retours Hicham 03/09) : les pastilles « i » encombraient le centre
         du radar — une par serie dessinee, soit jusqu'a six ronds gris empiles
         au milieu de la figure. Elles ne portaient qu'une infobulle au survol,
         qui redisait le nom de la famille deja lisible autour du graphe, et
         elles n'existent pas a l'impression. On les coupe. */
      withoutTooltips : true,
    }


  }

  const { addPopupNotif } = useContext(PopupNotifContext)  // E6 : toast d'export
  const handleExport = () => {
    let filename = 'Export '+languageValues?.adminDashboard?.certification[actLanguage]+' ' + actEcole?.name + ', ' + Moment().format('DD/MM/YYYY') + ', ' + Moment().format('HH')+'h'+Moment().format('mm')
    const renameKeys = (keysMap, objs) => {
      for (let i=0; i<objs.length;i++) {
        let obj = objs[i]
        objs[i] = Object.keys(obj).reduce(
        (acc, key) => ({
            ...acc,
            ...{ [keysMap[key] || key]: obj[key] }
        }),
        {})
      }
      return objs
    }

    /* F5 et F6 (retours Hicham 03/09) : l'export d'un apprenant ne portait ni le
       nom de son diplome ni les seuils de certification. Les deux colonnes sont
       ajoutees, dans l'ordre de lecture de la fiche. */
    let fieldsRename = {
      userName : languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      diplome : languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      nomDiplome : languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage],
      /* ⚠️ Le champ s'appelle `anneeDiplome` mais porte l'ANNEE D'ETUDE :
         `res.icebreakerResults?.annees` (l.436). Le nom est un reste de
         l'epoque ou il portait le diplome. Le libelle suit la donnee, pas le
         nom de la variable — le tableau juste au-dessus dit deja
         « Annee d'etude » pour cette meme valeur. */
      anneeDiplome : languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage],
      campus : languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      status : languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage],
      level : languageValues?.adminDashboard?.monitoringTable?.level[actLanguage],
      seuils : languageValues?.adminDashboard?.dashCertif?.seuilsExport?.[actLanguage],
    }
    let fieldsExport = [
      languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.level[actLanguage],
      languageValues?.adminDashboard?.dashCertif?.seuilsExport?.[actLanguage],
    ]

    let toAddToExport = JSON.parse(JSON.stringify(filteredData))
    toAddToExport.forEach((res) => {
      if (!res.anneeDiplome) {
        res.anneeDiplome = "-"
      }
      if (!res.nomDiplome) {
        res.nomDiplome = "-"
      }

      // « Rigueur 62/50 · Empathie 41/50 » — score obtenu et seuil, par competence
      const seuils = seuilsDuGroupe(res.groupeID)
      res.seuils = seuils.length === 0 ? "-" : seuils.map((s) => {
        const obtenu = scoreObtenu(res, s.key)
        return s.key + " " + (obtenu === null ? "-" : obtenu) + "/" + s.seuil
      }).join(" · ")

      if (res.status === "notStarted") {
        res.status = languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]
      } else if (res.status === "inProgress") {
        res.status = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]+" "+res.statusProgress+"%"
      } else if (res.status === "ended") {
        res.status = languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]
      }

      if (res.level === "inProgress") {
        res.level = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
      } else if (res.level === "notAcquired") {
        res.level = languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]
      } if (res.level === "acquired") {
        res.level = languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]
      } if (res.level === "rattrapage") {
        res.level = languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]
      }

      let findCampus = actEcole?.campus?.find((el) => el.id === res.campusID)
      let textCampus = "-"
      if (findCampus?.name) {
        textCampus = findCampus?.name
      }
      res.campus = textCampus

    })

    let rename = renameKeys(fieldsRename,  toAddToExport);
    let csv = csvFormat(rename, fieldsExport);
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename+'.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    addPopupNotif({ uuid : uuidv4(), title : languageValues?.notifExport[actLanguage], type : "confirm", removeAfter : 4000 })  // E6
  }

  const [viewGraph, setViewGraph] = useState(false)

  /* F8 : la recherche s'applique par-dessus les filtres, exactement comme dans le
     Suivi — insensible a la casse et aux accents. La pagination et le compteur
     « X sur Y » suivent la liste reellement affichee, sinon on obtient des pages
     vides (piege deja rencontre le 02/09 sur le Suivi). */
  const apprenantsAffiches = React.useMemo(() => {
    if (!recherche.trim()) return filteredData
    const plat = (t) => String(t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    return filteredData.filter((ap) => plat(ap.userName).includes(plat(recherche)))
  }, [filteredData, recherche])

  const nbrPagesAffichees = Math.max(1, Math.ceil(apprenantsAffiches.length / 25))
  const pageCourante = Math.min(page, nbrPagesAffichees)

  /* B4 (retours Hicham 03/09) : meme regle que le Suivi (point 4 du 04/08). La
     colonne « Certification » n'a de sens que si au moins un groupe de l'ecole
     porte un diplome renseigne en admin ; sinon elle affichait « - » partout. */
  const aUneCertification = Boolean(
    actEcole?.groupes?.some((g) => g?.diplome && String(g.diplome).trim() !== "")
  )

  /* C3 : les donnees du radar sont calculees UNE fois par rendu, et la legende
     se deduit de ce qui est reellement dessine — pas d'une condition parallele
     qui peut diverger (motif M19 : un trait sans legende, ou une legende sans
     trait). Declare apres tous les etats et apres `getDatasForChart`, jamais
     avant : une `const` lue trop tot vide l'ecran (motif M13). */
  const donneesRadar = selectedID !== null ? getDatasForChart(selectedID) : null

  return (
    <>
      <Hidden smUp>
        <SelectEcoleMenuMobile />
      </Hidden>


      <Box
        sx={{
          flex:1,
          padding:["20px", "50px", "50px", "80px"],
          backgroundColor:"background.grey",
        }}
      >
        <Header
          title={languageValues?.adminDashboard?.certification[actLanguage]}
          dataLoaded={dataLoaded && glbData !== null && filteredData.length !== 0}
        />

        {(dataLoaded && glbData !== null) ? (
          <>
            <Box sx={{
              display:"flex",
              gap:"10px",
              justifyContent:"space-between",
            }}>
              <Box sx={{
                marginTop:"35px",
                display:"flex",
                gap:["8px", "8px", "15px", "15px"],
                flexDirection:["column", "column", "row", "row"],
                alignItems:"flex-start",
              }}>
                <Button
                  ref={popoverRef}
                  disabled={!dataLoaded}
                  variant="contained"
                  disableRipple
                  sx={{
                    height:"40px !important",
                    minHeight:"40px !important",
                    flexShrink:0,
                    textTransform:"none",
                    background:"white",
                    color:"text.black",
                    boxShadow:"none",
                    border:"1px solid #E7E7E7",
                    fontSize:"14px !important",
                    gap:"8px",
                    '&:hover': {
                      background:"white",
                      border:"1px solid black",
                    },
                  }}
                  onClick={() => { setPopoverFilters(true) }}
                >
                  <img src={searchIcon} style={{width:"14px"}} />
                  <span>
                    {languageValues?.adminDashboard?.filters?.addFilter[actLanguage]}
                  </span>
                </Button>
                {/* F7 (retours Hicham 03/09) : meme presentation que le Suivi —
                    deroulants en ligne sur grand ecran, avec les memes regles
                    d'affichage (un menu n'apparait que si la dimension existe pour
                    cette ecole). Les dimensions sont celles de la Certification :
                    Groupe, Campus, Annee, Avancement, Niveau. */}
                <Hidden mdDown>
                  <FiltresInline
                    filters={filters} setFilters={setFilters}
                    menus={[
                      ...(actEcole?.groupes?.length > 1 ? [{ cle:"groupe", titre: languageValues?.adminDashboard?.filters?.groupe[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.groupeSub[actLanguage], datas: actEcole?.groupes || [], dataToDisplay:["diplome", "name"], dataToCheck:"groupeID", filterType:"groupes" }] : []),
                      ...(actEcole?.campus?.length > 1 ? [{ cle:"campus", titre: languageValues?.adminDashboard?.filters?.campus[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.campusSub[actLanguage], datas: actEcole?.campus || [], dataToDisplay:"name", dataToCheck:"id", filterType:"campus" }] : []),
                      /* Ce filtre porte sur l'ANNEE D'ETUDE : il lit
                         `icebreakerResults.annees` et propose `anneesReps`. Il etait
                         conditionne par `diplome` et intitule « Annee de
                         certification » — il pouvait donc s'afficher pour une ecole
                         qui ne pose pas la question, et filtrer sur du vide. */
                      ...(actEcole?.icebreakerQuestions?.annees === true ? [{ cle:"annee", titre: languageValues?.adminDashboard?.filters?.studyYear[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage], datas: actEcole?.icebreakerQuestions?.anneesReps || [], filterType:"anneesDiplome" }] : []),
                      { cle:"status", titre: languageValues?.adminDashboard?.filters?.progress[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.progressSub[actLanguage], datas: statusTypes, filterType:"status" },
                      { cle:"level", titre: languageValues?.adminDashboard?.filters?.level[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.levelSub[actLanguage], datas: levelTypes, filterType:"level" },
                    ]}
                  />
                </Hidden>
                {/* F8 : barre de recherche identique a celle du Suivi */}
                <Box sx={{
                  display:"flex", alignItems:"center", gap:"8px",
                  height:"40px", background:"white",
                  border:"1px solid #E7E7E7", padding:"0 12px",
                  borderRadius:"4px",
                }}>
                  <img src={searchIcon} style={{width:"14px"}} />
                  <input
                    value={recherche}
                    onChange={(e) => { setRecherche(e.target.value); setPage(1) }}
                    placeholder={languageValues?.adminDashboard?.rechercheApprenant?.[actLanguage]}
                    style={{ border:"none", outline:"none", fontSize:"14px", fontFamily:"Questrial", width:"170px", background:"transparent" }}
                  />
                </Box>
                <FiltersDisplay filters={filters} setFilters={setFilters} contents={glbData.contents} defaultF={defautFilters}/>
              </Box>
              <Button
                disabled={!dataLoaded}
                variant="contained"
                disableRipple
                sx={{
                  marginTop:"35px",
                  height:"40px !important",
                  minHeight:"40px !important",
                  flexShrink:0,
                  textTransform:"none",
                  background:"white",
                  color:"text.black",
                  boxShadow:"none",
                  border:"1px solid #E7E7E7",
                  fontSize:"14px !important",
                  gap:"8px",
                  minWidth:"0 !important",
                  '&:hover': {
                    background:"white",
                    border:"1px solid black",
                  },
                }}
                onClick={() => { handleExport() }}
              >
                <img src={exportIcon} style={{width:"15px"}} />
                <Hidden mdDown>
                  <span>
                    {languageValues?.adminDashboard?.exportTable[actLanguage]}
                  </span>
                </Hidden>
              </Button>
            </Box>

            <Box sx={{display:"flex", gap:selectedID === null ? "0%" : "2%", transition: "all 0.5s ease-out",}}>
              <Box sx={{flex : 1, flexShrink: 1,}}>

                { /* TABLE */}
                {/* S2, meme motif que le Suivi : `minWidth: 100%` + le
                    `table-layout: auto` par defaut faisaient dependre chaque
                    largeur de colonne du texte le plus long affiche. Toute
                    action qui change les lignes (filtre, recherche, page,
                    ouverture du volet apprenant) redessinait le tableau.
                    Largeurs fixes, « Nom » absorbe le reste. */}
                <TableContainer sx={{marginTop:"25px"}}>
                  <Table
                    sx={{ width: '100%', tableLayout: 'fixed' }}
                  >
                    <TableHead>
                      <TableRow sx={{
                        background: "#FAF8F6",
                        '& th': {
                          color:"text.subTitle",
                          fontSize:"15px",
                          border:"1px solid #E7E7E7"
                        }
                      }}>
                        <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL_CERTIF.nom}}>
                          {languageValues?.adminDashboard?.monitoringTable?.name[actLanguage]}
                        </TableCell>
                        {/* B4 (retours Hicham 03/09) : ces deux colonnes avaient ete
                            retirees du Suivi le 04/08 mais etaient restees ici sans
                            condition. On reprend a l'identique les regles du Suivi :
                            « Certification » seulement si un groupe de l'ecole porte
                            un diplome renseigne, « Campus » seulement si l'ecole en a
                            plus d'un. L'en-tete etait en prime decale d'une cellule
                            par rapport au corps : le libelle « Certification »
                            surplombait la colonne du diplome.
                            Cf JOURNAL-DES-ERREURS.md, entree B4. */}
                        {aUneCertification &&
                          <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL_CERTIF.certification}}>
                            {languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage]}
                          </TableCell>
                        }
                        <Hidden smDown>
                          {actEcole?.icebreakerQuestions?.annees === true &&
                            <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL_CERTIF.anneeEtude, whiteSpace: "nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
                              {languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage]}
                            </TableCell>
                          }
                        </Hidden>
                        {actEcole?.campus?.length > 1 &&
                          <Hidden mdDown>
                            <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL_CERTIF.campus}}>
                              {languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage]}
                            </TableCell>
                          </Hidden>
                        }
                        <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL_CERTIF.progression}}>
                          {languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage]}
                        </TableCell>
                        <Hidden smDown>
                          <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL_CERTIF.niveau}}>
                            {languageValues?.adminDashboard?.monitoringTable?.level[actLanguage]}
                          </TableCell>
                        </Hidden>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                    {apprenantsAffiches.slice(
                      (pageCourante-1) * 25,
                      ((pageCourante-1) * 25) + 25
                    ).map((row, index) => {
                      let findCampus = actEcole?.campus?.find((el) => el.id === row.campusID)
                      let textCampus = "-"
                      if (findCampus?.name) {
                        textCampus = findCampus?.name
                      }
                      return (
                        <TableRow
                          key={index}
                          onClick={(e) => {
                            setSelectedID(row)
                            setModalCertif(true)
                          }}
                          sx={{
                            background : row.userID === selectedID?.userID ? "#F2F0EF" : "white",
                            cursor:"pointer",
                            '& td': {
                              border:"1px solid #E7E7E7",
                            }
                          }}
                        >
                          <Hidden smDown>
                            <TableCell sx={{fontSize:"13px", color:"text.black", textTransform:"capitalize"}}>
                              {row.userName}
                            </TableCell>
                          </Hidden>
                          <Hidden smUp>
                            <TableCell sx={{fontSize:"13px", textTransform:"capitalize"}}>
                              <Box sx={{display:"flex", flexDirection:"column", gap:"2px"}}>
                                <Box sx={{fontSize:"13px", color:"text.black", textTransform:"capitalize"}}>{row.userName}</Box>
                                <Box sx={{fontSize:"12px", color:"text.subTitle", }}>{row.anneeDiplome ? row.anneeDiplome : "-"}</Box>
                              </Box>
                            </TableCell>
                          </Hidden>
                          <Hidden smDown>
                            {/* B4 : cette cellule EST la colonne « Certification »
                                (elle porte le diplome du groupe). Elle suit donc la
                                meme condition que son en-tete. */}
                            {aUneCertification &&
                              <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                                {row.diplome ? row.diplome : "-"}
                              </TableCell>
                            }
                          </Hidden>
                          <Hidden smUp>
                            <TableCell>
                              <Box sx={{display:"flex", flexDirection:"column", gap:"2px"}}>
                                <Box sx={{fontSize:"13px", color:"text.black",}}>{row.diplome ? row.diplome : "-"}</Box>
                                <Box sx={{fontSize:"12px", color:"text.subTitle",}}>
                                  {row?.level === 'notAcquired' &&
                                    <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                      <img src={closeRedRoundIcon} style={{width:"15px"}}/>
                                      <Box>
                                        <font>
                                          {languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                                        </font>
                                      </Box>
                                    </Box>
                                  }
                                  {row?.level === 'rattrapage' &&
                                    <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                      <img src={closeRedRoundIcon} style={{width:"15px"}}/>
                                      <Box>
                                        <font>
                                          {languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                                        </font>
                                      </Box>
                                    </Box>
                                  }
                                  {row?.level === 'acquired' &&
                                    <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                      <img src={checkGreenRoundIcon} style={{width:"15px"}}/>
                                      <Box>
                                        <font>
                                          {languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                                        </font>
                                      </Box>
                                    </Box>
                                  }
                                  {row?.level === 'inProgress' && languageValues?.adminDashboard?.levelTypes?.inProgress[actLanguage]}
                                </Box>
                              </Box>
                            </TableCell>
                          </Hidden>
                          <Hidden smDown>
                            {actEcole?.icebreakerQuestions?.annees === true &&
                              <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                                {row.anneeDiplome ? row.anneeDiplome : "-"}
                              </TableCell>
                            }
                          </Hidden>
                          {actEcole?.campus?.length > 1 &&
                            <Hidden mdDown>
                              <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                                {textCampus}
                              </TableCell>
                            </Hidden>
                          }
                          <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                            {row.status === "ended" &&
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                <img src={checkGreenRoundIcon} style={{width:"18px"}}/>
                                <Box>
                                  <Hidden mdDown>
                                    <font>
                                      {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                    </font>
                                  </Hidden>
                                </Box>
                              </Box>
                            }
                            {row.status === "inProgress" &&
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                <Box sx={{position:"relative"}}>
                                  <CircularProgress variant="determinate" value={100} thickness={5.5} size="18px" sx={{color: '#E7E7E7'}} />
                                  <CircularProgress
                                    variant="determinate"
                                    value={row.statusProgress}
                                    thickness={6}
                                    size="18px"
                                    sx={{
                                      color: "black",
                                      position: 'absolute',
                                      left: 0,
                                    }}
                                  />
                                </Box>
                                <Box>
                                  <Hidden mdDown>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusProgress[actLanguage]}
                                    {row.statusProgress}%
                                  </Hidden>
                                  <Hidden mdUp>
                                    {row.statusProgress}%
                                  </Hidden>
                                </Box>
                              </Box>
                            }
                            {row.status === "notStarted" &&
                              <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                <Box sx={{position:"relative"}}>
                                  <img src={sablierIcon} style={{height:"18px", marginLeft:"3px"}} />
                                </Box>
                                <Box>
                                  <Hidden mdDown>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusNotStarted[actLanguage]}
                                  </Hidden>
                                  <Hidden mdUp>
                                    {row.statusProgress}%
                                  </Hidden>
                                </Box>
                              </Box>
                            }
                          </TableCell>
                          <Hidden smDown>
                            <TableCell sx={{fontSize:"13px", color:"text.black",}}>
                              {row.level === 'notAcquired' &&
                                <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                  <img src={closeRedRoundIcon} style={{width:"18px"}}/>
                                  <Box>
                                    <Hidden mdDown>
                                      <font>
                                        {languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                                      </font>
                                    </Hidden>
                                  </Box>
                                </Box>
                              }
                              {row.level === 'rattrapage' &&
                                <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                  <img src={closeRedRoundIcon} style={{width:"18px"}}/>
                                  <Box>
                                    <Hidden mdDown>
                                      <font>
                                        {languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                                      </font>
                                    </Hidden>
                                  </Box>
                                </Box>
                              }
                              {row.level === 'acquired' &&
                                <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                                  <img src={checkGreenRoundIcon} style={{width:"18px"}}/>
                                  <Box>
                                    <Hidden mdDown>
                                      <font>
                                        {languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                                      </font>
                                    </Hidden>
                                  </Box>
                                </Box>
                              }
                              {row.level === 'inProgress' && languageValues?.adminDashboard?.levelTypes?.inProgress[actLanguage]}
                            </TableCell>
                          </Hidden>
                        </TableRow>
                      )
                    })}
                    </TableBody>
                  </Table>
                </TableContainer>
                { /* END TABLE */}

                { /* PAGINATION */}
                <Pagination
                  sx={{
                    display:"flex",
                    justifyContent:"center",
                    marginTop:"20px",
                    userSelect:"none",
                    '& .MuiPaginationItem-root' : {
                      color:"text.subTitle",
                    },
                    '& .MuiPaginationItem-root.MuiButtonBase-root' : {
                      background:"white",
                      border:"1px solid #E7E7E7",
                      color: "text.subTitle",
                      borderRadius:"0 !important",
                    },
                    '& .MuiPaginationItem-root.MuiButtonBase-root.Mui-selected' : {
                      background:"white",
                      border:"1px solid #E7E7E7",
                      color: "text.black",
                    },
                    '& .MuiPaginationItem-root.MuiButtonBase-root:hover' : {
                      background:"white",
                      color: "text.black",
                      border:"1px solid black",
                    },
                  }}
                  siblingCount={0}
                  boundaryCount={1}
                  count={nbrPagesAffichees}
                  page={pageCourante}
                  shape="rounded"
                  onChange={(e, page) => {
                    if (page) {
                      setPage(page)
                      if (popoverRef && popoverRef.current) {
                        popoverRef.current.scrollIntoView()
                      }
                    }
                  }}
                />

                <Box sx={{
                  display:"flex",
                  justifyContent:"center",
                  marginTop:"15px",
                  color:"text.subTitle",
                  fontSize:'13px',
                }}>
                  {apprenantsAffiches.length === 0 ? 0 : ((pageCourante-1) * 25) + 1}
                  {'-'}
                  {((pageCourante-1) * 25) + 25 > apprenantsAffiches.length ? apprenantsAffiches.length : ((pageCourante-1) * 25) + 25}
                  {' '}{languageValues?.adminDashboard?.paginationSur?.[actLanguage] || 'sur'}{' '}
                  {apprenantsAffiches.length}
                </Box>
                { /* END PAGINATION */}

              </Box>

              { /* RIGHT BOX FOR DESKTOP */}
              <Box
                id="flexTransitionDiv"
                onTransitionEnd={() => {
                  let actWidth = document?.getElementById("flexTransitionDiv")?.clientWidth
                  if (actWidth === 0) {
                    setViewGraph(false)
                  } else {
                    setViewGraph(true)
                  }
                }}
                sx={{position:"sticky", top:"0px", alignSelf:"flex-start", flexBasis : selectedID === null ? "0px" : "490px", transition: "all 0.5s ease-out", overflow:"hidden", flexShrink: 1, maxWidth:"490px", display:{xs : "none", lg:"flex"}}}
              >
                <Box sx={{width : "100%"}}>
                  <Box sx={{marginTop:"25px", background:"white", border:"1px solid #E7E7E7", width:"100%"}}>
                    <Box sx={{opacity:selectedID ? 1 : 0, padding:"30px 50px", overflow:"hidden", display:"flex", justifyContent:"space-between"}}>
                      <Box sx={{fontSize:"32px", padding:"20px 0px", color:"text.black", whiteSpace:"noWrap", overflow:"hidden", textOverflow:"ellipsis", textTransform:"capitalize"}}>
                        {selectedID?.userName}
                      </Box>
                      <Box>
                        <img
                          src={closeIcon}
                          style={{width:"18px", height:"18px", cursor:"pointer"}}
                          onClick={() => { setSelectedID(null); setModalCertif(false); }}
                        />
                      </Box>
                    </Box>
                    <Box sx={{opacity:selectedID ? 1 : 0, padding:"0px 50px", overflow:"hidden", display:"flex"}}>
                      {/* C1 (retours Nawal V3, 03/09) : cette case affichait le
                          diplome DU GROUPE, vide sur cette ecole — d'ou un
                          « Diplome - » parasite en haut du profil. Meme regle que
                          B4 : elle n'apparait que si un groupe de l'ecole porte
                          un diplome renseigne. Le nom du diplome de l'apprenant,
                          lui, vit dans son propre champ juste en dessous. */}
                      {aUneCertification &&
                        <Box sx={{flex:0.55, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                          {/* Le libelle de la colonne « Nom de diplome » devient
                              « Diplome » (retours Hicham 03/09). Cette case-ci
                              portait deja le mot « Diplome » pour une AUTRE
                              donnee — le diplome du groupe — et les deux se
                              suivent dans la fiche : deux libelles identiques
                              pour deux valeurs differentes. On la nomme
                              « Certification », comme le fait deja la colonne du
                              tableau qui porte cette meme valeur, et comme
                              l'export. */}
                          <Box sx={{color:"text.subTitle",}}>
                            {languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage]}
                          </Box>
                          <Box sx={{color:"text.black", fontSize:"18px"}}>
                            {selectedID?.diplome ? selectedID.diplome : "-"}
                          </Box>
                        </Box>
                      }
                      <Box sx={{flex:0.45, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                        <font style={{color:"text.subTitle",}}>
                          {/* `anneeDiplome` porte l'annee d'ETUDE (l.436) : le
                              libelle suit la donnee. */}
                          {languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage]}
                        </font>
                        <font style={{color:"text.black", fontSize:"18px"}}>
                          {selectedID?.anneeDiplome ? selectedID.anneeDiplome : "-"}
                        </font>
                      </Box>
                    </Box>
                    {/* F5 : le nom du diplome. Affichage adaptatif demande, car
                        « Licence professionnelle » cassait la mise en page : la
                        taille baisse d'un cran au-dela de 18 caracteres, le texte
                        se coupe proprement, et le nom complet reste lisible au
                        survol. */}
                    <Box sx={{opacity:selectedID ? 1 : 0, padding:"20px 50px 0px 50px", overflow:"hidden", display:"flex", flexDirection:"column", gap:"7px"}}>
                      <Box sx={{color:"text.subTitle",}}>
                        {languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage]}
                      </Box>
                      <Box
                        title={selectedID?.nomDiplome || ""}
                        sx={{
                          color:"text.black",
                          fontSize: String(selectedID?.nomDiplome || "").length > 18 ? "15px" : "18px",
                          whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis",
                        }}
                      >
                        {selectedID?.nomDiplome ? selectedID.nomDiplome : "-"}
                      </Box>
                    </Box>
                    <Box sx={{
                      opacity:selectedID ? 1 : 0,
                      marginTop:"40px",
                      padding:"0px 50px",
                      paddingBottom:"0px",
                      overflow:"hidden",
                      display:"flex",
                      marginBottom:viewGraph ? "0px" : "40px",
                     }}>
                      <Box sx={{flex:0.55, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                        <font style={{color:"text.subTitle", }}>
                          {languageValues?.adminDashboard?.monitoringTable?.progress[actLanguage]}
                        </font>
                        <font style={{color:"text.black", fontSize:"18px"}}>
                          {selectedID?.status === "ended" &&
                            <Box sx={{display:"flex", gap:"6px", height:"100%",}}>
                              <img src={checkGreenRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.status === "inProgress" &&
                            <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                              <Box sx={{position:"relative", height:"25px"}}>
                                <CircularProgress variant="determinate" value={100} thickness={5.5} size="20px" sx={{color: '#E7E7E7'}} />
                                <CircularProgress
                                  variant="determinate"
                                  value={selectedID.statusProgress}
                                  thickness={6}
                                  size="20px"
                                  sx={{
                                    color: "black",
                                    position: 'absolute',
                                    left: 0,
                                  }}
                                />
                              </Box>
                              <Box>
                                <Hidden mdDown>
                                  {languageValues?.adminDashboard?.monitoringTable?.statusProgress[actLanguage]}
                                  {selectedID.statusProgress}%
                                </Hidden>
                                <Hidden mdUp>
                                  {selectedID.statusProgress}%
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.status === "notStarted" &&
                            <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                              <Box sx={{position:"relative", height:"20px"}}>
                                <img src={sablierIcon} style={{height:"20px", marginLeft:"4px"}} />
                              </Box>
                              <Box>
                                <Hidden mdDown>
                                  {languageValues?.adminDashboard?.monitoringTable?.statusNotStarted[actLanguage]}
                                </Hidden>
                                <Hidden mdUp>
                                  {selectedID.statusProgress}%
                                </Hidden>
                              </Box>
                            </Box>
                          }
                        </font>
                      </Box>
                      <Box sx={{flex:0.45, overflow:"hidden", textOverflow:"ellipsis", display:"flex", flexDirection:"column", gap:"7px"}}>
                        <font style={{color:"text.subTitle",}}>
                          {languageValues?.adminDashboard?.monitoringTable?.level[actLanguage]}
                        </font>
                        <font style={{color:"text.black", fontSize:"18px"}}>
                          {selectedID?.level === 'notAcquired' &&
                            <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                              <img src={closeRedRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.level === 'rattrapage' &&
                            <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                              <img src={closeRedRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.level === 'acquired' &&
                            <Box sx={{display:"flex", alignItems:"center", gap:"6px", height:"100%"}}>
                              <img src={checkGreenRoundIcon} style={{width:"20px"}}/>
                              <Box>
                                <Hidden mdDown>
                                  <font>
                                    {languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            </Box>
                          }
                          {selectedID?.level === 'inProgress' && languageValues?.adminDashboard?.levelTypes?.inProgress[actLanguage]}
                        </font>
                      </Box>
                    </Box>
                    {(selectedID && viewGraph) &&
                      <>
                        <NewCertifChart
                          datas={donneesRadar}
                        />
                        {/* C3 : meme legende que le modal, importee du meme
                            fichier. L'entree « Seuil de certification » (C2
                            niveau 1) reste : sans elle, le trait de seuil dans
                            le radar n'est identifiable par personne. */}
                        <LegendeRadar donnees={donneesRadar} />
                        {/* C2 niveaux 2 et 3 (fiche V3 de Nawal, 03/09).
                            Niveau 1 (le seuil trace DANS le radar) est en place
                            plus haut, dans getDatasForChart. Le detail chiffre
                            n'a donc plus a occuper la zone principale : il
                            devient une zone secondaire, repliee par defaut,
                            ouverte par « Voir plus ». Niveau 3 : vert quand le
                            seuil est atteint, rouge sinon.
                            Rien ne s'affiche si le groupe n'a aucun seuil
                            configure — pas de valeur par defaut sur une donnee
                            qui appartient au client (JOURNAL-DES-ERREURS.md,
                            entree Q2, motif M11). */}
                        {seuilsApprenant.length > 0 &&
                          <Box sx={{padding:"0px 50px 30px 50px"}}>
                            <Box
                              component="button"
                              type="button"
                              onClick={() => { setDetailSeuilsOuvert(!detailSeuilsOuvert) }}
                              aria-expanded={detailSeuilsOuvert}
                              sx={{
                                display:"flex", alignItems:"center", gap:"7px",
                                background:"transparent", border:"none", padding:"0px",
                                cursor:"pointer", fontFamily:"inherit",
                                fontSize:"13px", color:"text.subTitle",
                                textDecoration:"underline", textUnderlineOffset:"3px",
                                '&:hover': { color:"text.black" },
                              }}
                            >
                              {/* TODO i18n : « Voir plus » / « Voir moins » n'existent pas
                                  encore dans LanguageContext.js (fichier confie a un autre
                                  chantier) — chaines en dur, FR/EN, a remonter dans le
                                  contexte des qu'il sera de nouveau modifiable. */}
                              {detailSeuilsOuvert
                                ? (actLanguage === "en" ? "See less" : "Voir moins")
                                : (actLanguage === "en" ? "See more" : "Voir plus")}
                              <Box component="span" sx={{fontSize:"9px"}}>
                                {detailSeuilsOuvert ? '▲' : '▼'}
                              </Box>
                            </Box>
                            {detailSeuilsOuvert &&
                              <Box sx={{marginTop:"14px"}}>
                                <Box sx={{color:"text.subTitle", fontSize:"13px", marginBottom:"12px"}}>
                                  {languageValues?.adminDashboard?.dashCertif?.seuilsTitre?.[actLanguage]}
                                </Box>
                                <Box sx={{display:"grid", gridTemplateColumns:"1fr auto", rowGap:"7px", columnGap:"14px"}}>
                                  {seuilsApprenant.map((s) => {
                                    const obtenu = scoreObtenu(selectedID, s.key)
                                    /* `obtenu === null` = competence non encore notee :
                                       ni vert ni rouge, on ne conclut pas a un echec. */
                                    const atteint = obtenu !== null && obtenu >= s.seuil
                                    const couleur = obtenu === null ? "text.subTitle" : (atteint ? "#2F7A3D" : "#B3402A")
                                    return (
                                      <React.Fragment key={s.key}>
                                        <Box sx={{display:"flex", alignItems:"center", gap:"8px", fontSize:"13px", color:"text.black", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
                                          <Box component="span" sx={{
                                            width:"8px", height:"8px", borderRadius:"50%", flexShrink:0,
                                            background: obtenu === null ? "#C9C6C4" : (atteint ? "#2F7A3D" : "#B3402A"),
                                          }} />
                                          {libelleAffichable(s.key)}
                                        </Box>
                                        <Box sx={{fontSize:"13px", whiteSpace:"nowrap", fontWeight:600, color: couleur}}>
                                          {obtenu === null ? "—" : obtenu + " %"}
                                          <Box component="span" sx={{color:"text.subTitle", fontWeight:400}}>{" / " + s.seuil + " %"}</Box>
                                        </Box>
                                      </React.Fragment>
                                    )
                                  })}
                                </Box>
                              </Box>
                            }
                          </Box>
                        }
                      </>
                    }
                  </Box>
                </Box>
              </Box>
              { /* END RIGHT BOX FOR DESKTOP */}


            </Box>

            <CertifModal
              isOpen={modalCertif}
              selectedID={selectedID}
              aUneCertification={aUneCertification}
              dataLoaded={dataLoaded}
              getDatasForChart={getDatasForChart}
              onClose={() => {
                setModalCertif(false)
                setTimeout(() => {
                  setSelectedID(null)
                }, 500)
              }}
            />


            <MyPopover
              isDrawerOpen={popoverFilters}
              anchorEl={popoverRef.current}
              handleClose={() => { setPopoverFilters(false) }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <ActionList
                glbData={glbData}
                filters={filters}
                setFilters={setFilters}
                icebreakerQuestions={actEcole?.icebreakerQuestions}
              />
            </MyPopover>
          </>
        ) : (
          aucuneDonnee === true ? (
            <NoDataScreen reseau={reseauCoupe} />
          ) : (
          <SkeletonEcran avecTable />
          )
        )}


      </Box>

    </>
  )
}


export default Certification
